// extracted by css-extract-rspack-plugin
module.exports =  {"carouselContainer":"bNxYF","carouselCard":"EDOy5","figure":"_mcQO","image":"sq4VN","content":"GF3JA","title":"cY81S"};